import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

const PAGE_VARIANTS = {
  initial: {
    opacity: 0,
    y: 14,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -10,
  },
};

const PAGE_TRANSITION = {
  duration: 0.3,
  ease: [0.22, 1, 0.36, 1],
};

const AnimatedOutlet = () => {
  const location = useLocation();
  const shouldReduceMotion = useReducedMotion();
  const routeKey = `${location.pathname}${location.search}`;

  if (shouldReduceMotion) {
    return <Outlet />;
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={routeKey}
        className="page-transition"
        initial="initial"
        animate="animate"
        exit="exit"
        variants={PAGE_VARIANTS}
        transition={PAGE_TRANSITION}
      >
        <Outlet />
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedOutlet;
